import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { UserMenu } from '../AppLayout/UserMenu';
import { AgencySidebar } from './AgencySidebar';
import styles from './AgencyLayout.module.css';

export function AgencyLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className={styles.layout}>
      <AgencySidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className={styles.mainColumn}>
        <header className={styles.topBar}>
          <div className={styles.topBarSpacer} />
          <UserMenu />
        </header>
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
